import { Component, OnInit, Inject, ViewChild, OnDestroy, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { tap } from 'rxjs/operators';
import { FileService } from '../../shared/services/file.service';
import { ChangeOrderInvoice, Invoice } from '../../shared/models/invoice.interface';
import { DatePipe } from '@angular/common';
import { JobFilter } from '../../job/models/job.filter';
import { User } from '../../shared/models/user.interface';
import { ExportService } from '../services/export.service';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-export-invoices',
  templateUrl: './export-invoices.component.html',
  styleUrls: ['./export-invoices.component.scss']
})
export class ExportInvoicesComponent extends AbstractBiditComponent implements OnInit, OnDestroy, AfterViewInit {

  dataSource = new MatTableDataSource<Invoice>();
  displayedColumns: string[] =
    ['projectNbr', 'changeOrder', 'customerName', 'projectName', 'bidAmount', 'exportDate', 'select'];

  salespersons: User[];

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(deviceDetectorService: DeviceDetectorService,
    private exportService: ExportService, private fileService: FileService) {
    super(deviceDetectorService);

  }

  filter: JobFilter = { salespersonId: '' } as JobFilter;


  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;

    this.refreshSummary();
  }

  ngAfterViewInit(): void {
    // reset the paginator after sorting
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    this.sort.sortChange
      .pipe(
        tap(() => this.loadJobs())
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this.sort.sortChange.unsubscribe();
  }

  refreshSummary() {
    this.loadSummary();
    this.loadJobs();
  }

  loadSummary() {
    this.exportService.getSalespersons()
      .subscribe({
        next: (data) => {
          this.salespersons = data;
        },
        error: (error: string) => this.errors = error
      });
  }

  loadJobs() {
    this.exportService.getList(this.filter, this.sort.active, this.sort.direction)
      .subscribe(invoices => this.dataSource.data = invoices);
  }

  toggleSelectAll(event) {
    this.dataSource.data.forEach((inv) => {
      inv.isSelected = event.checked;
    });
  }

  downloadInvoices() {
    let selectedJobs = this.dataSource.data.filter(inv => inv.changeOrder_ID == null && inv.isSelected).map(inv => inv.quote_ID);
    let selectedChangeOrders = this.dataSource.data.filter(inv => inv.changeOrder_ID != null && inv.isSelected).map(inv => inv.changeOrder_ID);

    //this.dataSource.data.filter(inv => inv.changeOrder_ID != null && inv.isSelected).map(inv => inv.changeOrder_ID);

    this.exportService.downloadInvoices(selectedJobs, selectedChangeOrders)
      .subscribe({
        next: (data) => {
          let pipe = new DatePipe('en-US');
          let fileDate = pipe.transform(Date.now(), 'yyyyMMdd HH:mm:ss');
          let filename = `invoiceExport_ ${fileDate}.csv`;
          this.fileService.downloadFile(data, filename);
        },
        error: (error: string) => this.onError(error)
      });
  }

}
